import { Email, GradientIcon } from '@sparemin/blockhead';
import React from 'react';
import AuthCard from '../AuthCard';
import {
  FORGOT_PASSWORD_SUCCESS_CARD_SUBTITLE,
  FORGOT_PASSWORD_SUCCESS_CARD_TITLE,
} from './constants';

export interface ForgotPasswordSuccessCardProps {}

const ForgotPasswordSuccessCard: React.FC<
  ForgotPasswordSuccessCardProps
> = () => (
  <AuthCard
    header={
      <AuthCard.Header
        icon={<GradientIcon>{<Email />}</GradientIcon>}
        title={FORGOT_PASSWORD_SUCCESS_CARD_TITLE}
        subtitle={FORGOT_PASSWORD_SUCCESS_CARD_SUBTITLE}
      />
    }
  />
);

export default ForgotPasswordSuccessCard;
